
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model } from '../../controlador';
    import { Cliente } from '@/__env/lib/Clientes';
    import pregunta from './pregunta-pregunta.vue';
    import publicacion from './pregunta-pregunta-publicacion.vue';
    import responder from './pregunta-responder.vue';
    import { Pregunta } from '@/__env/lib/MercadoLibre/Preguntas';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            pregunta,
            publicacion,
            responder,
        }
    } )
    export default class Componente extends Vue
    {
        public get Controlador() { return Model; }

        public tab: string = '';
        public Estado: 'ok' | 'cargando' = 'cargando';
        Pregunta: Pregunta = new Pregunta();

        Respuesta: string = '';
        @Watch( 'Respuesta' )
        onRespuesta()
        {

        }


        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }
        async mounted()
        {
            this.Pregunta = this.Controlador.PreguntaSeleccionada;
            this.Estado = "ok";
        }

        public Rapidas: boolean = false;
        public Refresh: boolean = true;
        public Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => { this.Refresh = true; } );
        }

    }
